import { useLocation } from 'react-router-dom';
import { fromLegacyPath } from '../HeadcountRoutes';

export const useLegacyRedirectTarget = (): string => {
  const { pathname, search } = useLocation();
  return fromLegacyPath(pathname, search);
};
